type Breakpoint = {
  min: number
  max: number
}

export const breakpoints = {
  b0: { min: 0, max: 359 },
  b360: { min: 360, max: 411.999 },
  lighthouse: { min: 412, max: 412.999 }, // for lighthouse <3
  b440: { min: 413, max: 479.999 },
  b480: { min: 480, max: 679.999 },
  b680: { min: 680, max: 767.999 },
  b768: { min: 768, max: 991.999 },
  b992: { min: 992, max: 1279.999 },
  b1280: { min: 1280, max: 1679.999 },
  b1680: { min: 1680, max: 1919.999 },
  b1920: { min: 1920, max: Infinity },
} as const satisfies Record<string, Breakpoint>

export type BreakpointName = keyof typeof breakpoints

export type BreakpointImageConfig = {
  width: number
  height: number
}

export type ResponsiveImageConfig = Partial<
  Record<BreakpointName, BreakpointImageConfig>
>
